<template>
    <main-content with_go_back_bar>
        <kt-panel>
           <kt-panel-body>
               <div class="w-100 text-center" id="qr"></div>
                <div class="kt-input-icon kt-input-icon--right w-50 m-auto">
                    <kt-input-group class="">                        
                        <kt-input-group-append class="click-to-copy" :style="{cursor: 'pointer'}" v-clipboard:copy="$url(product.pay_link)">
                            <kt-input-group-text>
                                <i class="fa fa-clipboard"></i>
                            </kt-input-group-text>
                        </kt-input-group-append>
                        <kt-input-group-append>
                            <kt-input-group-text>
                                <a  target="_blank" :href="$url(product.pay_link)">
                                    <i class="fa fa-external-link-alt"></i>
                                </a>
                            </kt-input-group-text>
                        </kt-input-group-append>

                        <kt-form-control disabled dir="ltr" :value="$url(product.pay_link)"></kt-form-control>
                    </kt-input-group>
                </div>
                <div class="container mt-4">
                    <kt-row>
                        <kt-col xs="12" md="4">
                            <img class="product-image" :src="product.image_link" />
                        </kt-col>
                        <kt-col xs="12" md="6" class="pull-md-2">
                            <div>
                                <span>{{ product.title }}</span>
                            </div>
                            <div class="mt-3">
                                <span class="badge badge-danger badge-pill">{{ $t('label.amount') }}</span>
                                <span v-if="product.define_amount_by_user" class="float-right">{{ $t('label.define_amount_by_user') }}</span>
                                <span v-else class="float-right">{{ product.amount }} {{ $t('label.rial') }}</span>
                            </div>
                            <div class="mt-3">
                                <span class="badge badge-danger badge-pill">{{ $t('label.quantity') }}</span>
                                <span v-if="product.is_unlimited" class="float-right">{{ $t('label.unlimited') }}</span>
                                <span v-else class="float-right">{{ product.quantity }} {{ $t('label.number') }}</span>
                            </div>
                            <div v-if="product.tax" class="mt-3">
                                <span class="badge badge-danger badge-pill">{{ $t('label.tax') }}</span>
                                <span class="float-right">{{ $t('message.tax') }}</span>
                            </div>
                        </kt-col>
                    </kt-row>
                    <kt-row class="mt-4">
                        <kt-col xs="12">
                            <p>{{ product.description }}</p>
                        </kt-col>
                    </kt-row>
                </div>

                <h4 :style="{marginBottom: '2rem', marginTop: '3rem'}">{{ $t('message.pay_link_settings') }}</h4>

                <kt-form-section>
                    <kt-row>
                        <kt-col xs="12">
                            <kt-form-group>
                                <kt-form-check
                                    disabled
                                    :checked="product.is_multiple"
                                >
                                    {{ $t('label.is_multiple') }}
                                </kt-form-check>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-form-section>

                <kt-form-section>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-check
                                    disabled
                                    :checked="product.address_option"
                                >
                                    {{ $t('label.address_option') }}
                                    <div class="d-inline" v-if="product.address_option">
                                        <div class="d-inline badge badge-primary badge-pill ml-3" v-if="product.address_option_switch">{{ $t('label.required') }}</div>
                                        <div class="d-inline badge badge-secondary badge-pill ml-3" v-else>{{ $t('label.optional') }}</div>
                                    </div>
                                </kt-form-check>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-form-section>

                <kt-form-section>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-check
                                    disabled
                                    :checked="product.name_option"
                                >
                                    {{ $t('label.name_option') }}
                                    <div class="d-inline" v-if="product.name_option">
                                        <div class="d-inline badge badge-primary badge-pill ml-3" v-if="product.name_option_switch">{{ $t('label.required') }}</div>
                                        <div class="d-inline badge badge-secondary badge-pill ml-3" v-else>{{ $t('label.optional') }}</div>
                                    </div>
                                </kt-form-check>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-form-section>

                <kt-form-section>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-check
                                    disabled
                                    :checked="product.email_option"
                                >
                                    {{ $t('label.email_option') }}
                                    <div class="d-inline" v-if="product.email_option">
                                        <div class="d-inline badge badge-primary badge-pill ml-3" v-if="product.email_option_switch">{{ $t('label.required') }}</div>
                                        <div class="d-inline badge badge-secondary badge-pill ml-3" v-else>{{ $t('label.optional') }}</div>
                                    </div>
                                </kt-form-check>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-form-section>

                <kt-form-section>
                    <kt-row>
                        <kt-col lg="6" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-check
                                    disabled
                                    :checked="product.phone_option"
                                >
                                    {{ $t('label.phone_option') }}
                                    <div class="d-inline" v-if="product.phone_option">
                                        <div class="d-inline badge badge-primary badge-pill ml-3" v-if="product.phone_option_switch">{{ $t('label.required') }}</div>
                                        <div class="d-inline badge badge-secondary badge-pill ml-3" v-else>{{ $t('label.optional') }}</div>
                                    </div>
                                </kt-form-check>
                            </kt-form-group>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
           </kt-panel-body>
       </kt-panel>
    </main-content>
</template>

<script>
import { mapGetters } from 'vuex'
import mainContent from '@/components/main-content'
import QrCodeWithLogo from 'qr-code-with-logo'
import LocalImage from '@/assets/media/logoemail.png'
import $ from 'jquery'
import 'bootstrap-switch'

export default {
    components: {
        mainContent,
    },
    computed: {
        ...mapGetters('product', [
            'product', 'status'
        ]),
        qr_canvas() {
            const qr_canvas = document.createElement('canvas')
            document.getElementById('qr').appendChild(qr_canvas)

            return qr_canvas
        }
    },
    data() {
        return {
            hashid: this.$route.params.hashid,
            store_hashid: this.$route.params.store_hashid
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('product/find', vm.hashid)
        })
    },
    watch: {
        product: function(product) {
            if(product.pay_link) {
                this.createQrCode()
            }
        }
    },
    mounted() {
        if(this.product.pay_link) {
            this.createQrCode()
        }

        $('[data-switch=true]').bootstrapSwitch('size', 'mini')
        $('[data-switch=true]').on('switchChange.bootstrapSwitch', (e, data) => {
            this.query[e.target.id] = data
        }) 
    },
    methods: {
        createQrCode() {
            QrCodeWithLogo.toCanvas({
                canvas: this.qr_canvas,
                content: this.$url(this.product.pay_link),
                width: 200,
                logo: {
                    src: LocalImage,
                    borderRadius: '50',
                    bgColor: '#fff'
                }
            })
        },
    }
}
</script>

<style lang="scss">
.click-to-copy, .click-to-copy i {
    transition: all 0.5s;
}
.click-to-copy:hover, .click-to-copy:focus {
    zoom: 1.1;
}
.click-to-copy:hover i, .click-to-copy:focus i {
    color: #5867dd;
}
.product-image {
    width: 100%;
    height: auto;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3);
}
.z-depth-0 {
    box-shadow: none!important;
}
.z-depth-1 {
    box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
}
.z-depth-2 {
    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3);
}
.z-depth-3 {
        box-shadow: 0 8px 17px 2px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);
}
.z-depth-4 {
    box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
}
</style>